import { render, staticRenderFns } from "./GroupLinkNode.vue?vue&type=template&id=4b65b24b"
import script from "./GroupLinkNode.vue?vue&type=script&lang=js"
export * from "./GroupLinkNode.vue?vue&type=script&lang=js"
import style0 from "./GroupLinkNode.vue?vue&type=style&index=0&id=4b65b24b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports